// extracted by mini-css-extract-plugin
export var centerText = "_6p-8";
export var container = "_6p-0";
export var doughnutContainer = "_6p-7";
export var legend = "_6p-a";
export var legendItemColorDisplay = "_6p-b";
export var legendItemLabel = "_6p-d";
export var legendItemValue = "_6p-c";
export var lg = "_6p-5";
export var maxWidth = "_6p-9";
export var md = "_6p-4";
export var responsive = "_6p-6";
export var sm = "_6p-3";
export var xs = "_6p-2";
export var xxs = "_6p-1";